import {
  MAIL_FAILURE_FALLBACK,
  RECEIPT_CONFIRMATION_FAILURE_LABELS,
  type TicketReceiptConfirmation,
} from '@easyhelp/shared';

/**
 * La conferma di ricezione a chi ha segnalato nel thread (#117), in una frase. Lo stato di consegna
 * (consegnata, non recapitata…) lo dice l'etichetta accanto all'intestazione, come per le risposte.
 */
export function receiptConfirmationText({ delivery, failure }: TicketReceiptConfirmation): string {
  switch (delivery) {
    case 'in_invio':
      return 'Conferma di ricezione in invio a chi ha segnalato.';
    case 'fallita':
      return `Conferma di ricezione non inviata a chi ha segnalato: ${
        (failure && RECEIPT_CONFIRMATION_FAILURE_LABELS[failure]) ?? MAIL_FAILURE_FALLBACK
      }.`;
    default:
      return 'Conferma di ricezione inviata a chi ha segnalato.';
  }
}
